import React from "react";
import { motion } from "framer-motion";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6">
    <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Branding Column */}
        <div>
          <h3 className="text-2xl font-bold mb-6">Dubai EmeraldVault</h3>
          <p className="text-gray-400 mb-6 leading-relaxed">
            Pioneers of Panjshir emerald luxury since 1985, delivering the world’s No. 1 gems with unmatched brilliance and investment value worldwide.
          </p>
          <div className="flex space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-300 transition-colors">
              <Facebook className="h-6 w-6" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-300 transition-colors">
              <Twitter className="h-6 w-6" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-300 transition-colors">
              <Instagram className="h-6 w-6" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-300 transition-colors">
              <Linkedin className="h-6 w-6" />
            </a>
          </div>
        </div>

        {/* Quick Links Column */}
        <div>
          <h4 className="text-lg font-semibold mb-6 border-b border-gray-800 pb-2">Quick Links</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/mining" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Mining
              </Link>
            </li>
            <li>
              <Link to="/pricing-plans" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Investment
              </Link>
            </li>
            <li>
              <Link to="/whyus" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Why Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Collections Column */}
        <div>
          <h4 className="text-lg font-semibold mb-6 border-b border-gray-800 pb-2">Collections</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/shop-roughemerald" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Rough Panjshir Emeralds
              </Link>
            </li>
            <li>
              <Link to="/shop-cutemerald" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Cut Panjshir Emeralds
              </Link>
            </li>
          </ul>
        </div>

        {/* Support Column */}
        <div>
          <h4 className="text-lg font-semibold mb-6 border-b border-gray-800 pb-2">Support</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/FaqPage" className="text-gray-400 hover:text-emerald-300 transition-colors">
                FAQ
              </Link>
            </li>
            <li>
              <Link to={'/ShipingPage'} className="text-gray-400 hover:text-emerald-300 transition-colors">
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/contactus" className="text-gray-400 hover:text-emerald-300 transition-colors">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-800 mt-10 pt-8 text-center text-gray-400 text-sm">
        <p>© {new Date().getFullYear()} Dubai EmeraldVault. All rights reserved.</p>
      </div>
    </div>
  </footer>
  );
}
